// extracted by mini-css-extract-plugin
module.exports = {"reportWrapper":"style__reportWrapper__jd-aw"};